import React, {Component} from 'react';
import { observer , inject } from 'mobx-react';
import { getInitiation,  getAnnualFee, getAmountDueToday, getSaleDuration, getPaymentAndTerm , isCommitVerbage } from './ProductInfoItems.js';

class PrepaidProduct extends Component {

    membershipDetailsPressed(e){
        //product ID's and club ID's
        this.props.DGRStore.setProductID(e.target.name)

        this.props.DGRModalStore.setSection('productDetails')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }
    selectProductPressed(e){
        const {selectFunction} = this.props
        selectFunction(e)
    }
    getPrepaidPhoto( product_name ) {
        switch( product_name ) {
            case 'All-Club Sport':
                return '/go/dgr/static/img/gym/photo1.jpg';
            case 'All-Club Super-Sport':
                return '/go/dgr/static/img/gym/photo2.jpg';
            case 'All-Club Ultra-Sport':
                return '/go/dgr/static/img/gym/photo3.jpg';
            case 'One-Club Commit':
                return '/go/dgr/static/img/gym/photo4.jpg';
            case 'One-Club 7 Day':
                return '/go/dgr/static/img/gym/photo5.jpg';
            case 'One-Club 30 Day':
                return '/go/dgr/static/img/gym/photo6.jpg';
            case 'One-Club 90 Day':
                return '/go/dgr/static/img/gym/photo7.jpg';
            case 'One-Club 1 Year':
                return '/go/dgr/static/img/gym/photo8.jpg';
            default:
                return '/go/dgr/static/img/gym/photo1.jpg';
        }
    }
    constructor(props){
        super(props);
        this.membershipDetailsPressed = this.membershipDetailsPressed.bind(this)
        this.selectProductPressed = this.selectProductPressed.bind(this)
    }
    render(){
        const product = this.props.product
        return (
                <div className="prepaidProductCard">
                <div className="prepaidProductCardFlex">
                    <div className="leftImg">
                        <div className="fill">
                            <img alt='' src={ this.getPrepaidPhoto( product.name ) }/>
                        </div>
                    </div>
                    <div className="leftProduct">
                        <div className="title">
                          <span className="titleName">{product.name}</span>
                        </div>
                        <div className="productInfo">
                            <p className="subinfo">
                              Prices do not include sales tax. {isCommitVerbage(product)}
                              &nbsp;
                              <button
                              className="memberDetails"
                              name={ product.popup_id }
                              onClick={this.membershipDetailsPressed}>
                                  See Membership Details
                              </button>
                              {getSaleDuration(product)}
                            </p>
                        </div>
                    </div>
                    <div className="rightProduct">
                            {getPaymentAndTerm(product)}
                            {getInitiation(product)}
                            {getAnnualFee(product)}
                            {getAmountDueToday(product)}
                            <button
                                onClick= {this.selectProductPressed}
                                name={product.id}
                                value={product.id}
                                className="bigButton">Select
                            </button>
                    </div>
                </div>
                </div>
        )
    }
}

PrepaidProduct = inject('DGRStore','DGRModalStore')(observer(PrepaidProduct  ))
export default PrepaidProduct



// WEBPACK FOOTER //
// ./src/components/DGR/MembershipOptions/PrepaidProduct.js